import { render } from "./AutomationLandingCard.vue?vue&type=template&id=7970930c&scoped=true"
import script from "./AutomationLandingCard.vue?vue&type=script&lang=js"
export * from "./AutomationLandingCard.vue?vue&type=script&lang=js"

import "./AutomationLandingCard.vue?vue&type=style&index=0&id=7970930c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7970930c"]])

export default __exports__